import { CharField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { TipologiaImmagine } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function TipologiaImmagineForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<TipologiaImmagine>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <CharField
        label="Nome plurale"
        layout="horizontal"
        value={values.nome_plurale}
        onChange={(value) => {
          setFieldValue("nome_plurale", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome_plurale") : undefined}
        errorMessage={getIn(errors, "nome_plurale")}
        required
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />
      <SwitchField
        label="Mostra nella pagina CIPEC"
        layout="horizontal"
        value={values.mostra_in_cipec}
        onChange={(checked) => {
          setFieldValue("mostra_in_cipec", checked)
        }}
      />
    </Col>
  )
}
